import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { submitRating } from '../lib/feedback.js'

/*
 * Quick "Rate this calculator" star widget. One rating per browser (localStorage).
 * Anonymous — just a 1–5 star tap, stored in Supabase. After rating, points to the
 * full feedback form for anyone who wants to say more.
 */
const KEY = 'pc:rated'

export default function RatingWidget() {
  const { pathname } = useLocation()
  const [rated, setRated] = useState(false)
  const [hover, setHover] = useState(0)
  const [value, setValue] = useState(0)

  useEffect(() => {
    try { if (localStorage.getItem(KEY)) setRated(true) } catch { /* private mode */ }
  }, [])

  const rate = async (n) => {
    setValue(n)
    setRated(true)
    try { localStorage.setItem(KEY, String(n)) } catch { /* ignore */ }
    await submitRating(n, pathname) // fire-and-forget; UI already thanked them
  }

  return (
    <div className="rate-widget">
      {rated ? (
        <p className="rate-thanks">
          ⭐ Thanks for the feedback! <Link to="/feedback">Got more to say?</Link>
        </p>
      ) : (
        <div className="rate-row">
          <span className="rate-label">Rate this calculator</span>
          <div className="rate-stars" role="radiogroup" aria-label="Rate this calculator 1 to 5 stars">
            {[1, 2, 3, 4, 5].map((n) => (
              <button
                key={n}
                type="button"
                className={`rate-star${(hover || value) >= n ? ' on' : ''}`}
                aria-label={`${n} star${n > 1 ? 's' : ''}`}
                onMouseEnter={() => setHover(n)}
                onMouseLeave={() => setHover(0)}
                onFocus={() => setHover(n)}
                onBlur={() => setHover(0)}
                onClick={() => rate(n)}
              >
                ★
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
